import { useEffect, useCallback } from 'react';
import { useTaxYearStore } from '../store/taxYearStore';
import {
  getFallbackTaxYearConfig,
  getTaxYearConfig,
} from '../services/taxYearService';

/**
 * Provides selected tax year and supported years for the dropdown.
 * Fetches config from GET /api/tax-year (with backend-aligned fallback).
 */
export function useTaxYear() {
  const defaultYear = useTaxYearStore((s) => s.defaultYear);
  const selectedYear = useTaxYearStore((s) => s.selectedYear);
  const availableYears = useTaxYearStore((s) => s.availableYears);
  const configFetched = useTaxYearStore((s) => s.configFetched);
  const applyConfig = useTaxYearStore((s) => s.applyConfig);
  const setSelectedYear = useTaxYearStore((s) => s.setSelectedYear);
  const getEffectiveYear = useTaxYearStore((s) => s.getEffectiveYear);

  const fetchConfig = useCallback(async () => {
    if (configFetched) return;
    try {
      const config = await getTaxYearConfig();
      applyConfig(config.supportedYears, config.defaultTaxYear);
    } catch (err) {
      console.error('Failed to fetch tax year config', err);
      const fallback = getFallbackTaxYearConfig();
      applyConfig(fallback.supportedYears, fallback.defaultTaxYear);
    }
  }, [configFetched, applyConfig]);

  useEffect(() => {
    fetchConfig();
  }, [fetchConfig]);

  return {
    defaultYear,
    selectedYear: selectedYear ?? defaultYear,
    effectiveYear: getEffectiveYear(),
    availableYears,
    setSelectedYear,
    isLoading: !configFetched,
  };
}
